import { useMemo, useState, useEffect } from 'react';
import { getKBLibraryPreviewData } from '../data/KBLibraryPreview';
import Raven from 'raven-js';
import { getRecommendedArticles, getArticleCategories } from '../../knowledge-base/clients/kb-api.v3';
const useKBLibraryData = ({
  knowledgeBaseId,
  knowledgeBaseUrl,
  kbRecommendationType,
  knowledgeBaseEnabled,
  isKnowledgeBaseV3,
  isUngatedForKBImprovement
}) => {
  const {
    defaultRecommendedArticles,
    defaultArticleCategories
  } = useMemo(() => getKBLibraryPreviewData(), []);
  const [recommendedArticles, setRecommendedArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (!knowledgeBaseEnabled || !knowledgeBaseId || !isKnowledgeBaseV3) {
      setRecommendedArticles(isUngatedForKBImprovement ? defaultRecommendedArticles : []);
      setCategories(isUngatedForKBImprovement ? defaultArticleCategories : []);
      setIsLoading(false);
      return;
    }
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const [articlesResponse, categoriesResponse] = await Promise.all([getRecommendedArticles({
          knowledgeBaseId,
          knowledgeBaseUrl,
          kbRecommendationType
        }), getArticleCategories({
          knowledgeBaseId,
          knowledgeBaseUrl
        })]);
        if (Array.isArray(articlesResponse === null || articlesResponse === void 0 ? void 0 : articlesResponse.results)) {
          setRecommendedArticles(articlesResponse.results);
        }
        if (Array.isArray(categoriesResponse)) {
          setCategories(categoriesResponse);
        }
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        if (error instanceof Error) {
          Raven.captureException(error);
        }
      }
    };
    void fetchData();
  }, [knowledgeBaseId, knowledgeBaseUrl, kbRecommendationType, knowledgeBaseEnabled, isKnowledgeBaseV3, defaultRecommendedArticles, defaultArticleCategories, isUngatedForKBImprovement]);
  return {
    recommendedArticles,
    categories,
    isLoading
  };
};
export default useKBLibraryData;